/**
 * Cart Add-on Modal - FINAL VERSION v2
 * 
 * SHOPIFY LIVE: Loads class with all data extraction code
 *               Does NOT activate modal or setup event listeners
 *               Everything remains normal - no modal appears
 *
 * CONVERT VARIANT: Activation script calls .activate() method
 *                  Modal appears and all functionality enabled
 *                  UpCart drawer blocked
 * 
 * CHANGE: Auto-closes and redirects to /cart after adding items
 */

class CartAddonModal {
  constructor(options = {}) {
    this.options = {
      modalId: options.modalId || 'cart-addon-modal',
      maxProducts: options.maxProducts || 5,
      selectorProductContainer: options.selectorProductContainer || '.cbb-also-bought-product',
      selectorAddToCartBtn: options.selectorAddToCartBtn || 'button[name="add"]',
      debugMode: options.debugMode || false,
      onModalOpen: options.onModalOpen || null,
      onModalClose: options.onModalClose || null,
      ...options
    };

    this.modal = null;
    this.products = [];
    this.isInitialized = false;
    this.addToCartInProgress = false;
    this.productTitle = '';

    this.init();
  }

  getProductTitle() {
    const shortTitle = document.querySelector('.product__title .short-title');
    if (shortTitle) {
      return shortTitle.textContent.trim();
    }
    
    const fullTitle = document.querySelector('.product__title .full-title');
    if (fullTitle) {
      return fullTitle.textContent.trim();
    }
    
    const h1 = document.querySelector('.product__title h1');
    if (h1) {
      return h1.textContent.trim();
    }
    
    return 'Product';
  }

  init() {
    try {
      this.log('Loading CartAddonModal class...');
      this.productTitle = this.getProductTitle();
      this.isInitialized = true;
      this.log('CartAddonModal class loaded (waiting for activation)');
      return true;
    } catch (error) {
      this.error('Initialization failed:', error);
      return false;
    }
  }

  activate() {
    try {
      this.log('🧪 Activating CartAddonModal...');
      
      if (!document.getElementById(this.options.modalId)) {
        this.createModal();
      }

      this.modal = document.getElementById(this.options.modalId);
      
      if (!this.modal) {
        this.error('Modal element not found in DOM');
        return false;
      }

      this.injectStyles();

      if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', () => this.setupEventListeners());
      } else {
        this.setupEventListeners();
      }

      this.log('🧪 CartAddonModal fully activated');
      return true;
    } catch (error) {
      this.error('Activation failed:', error);
      return false;
    }
  }

  createModal() {
    const modalHTML = `
      <div id="${this.options.modalId}" class="cart-addon-modal" style="display: none;">
        <div class="cart-addon-modal__overlay" data-action="close-modal"></div>
        <div class="cart-addon-modal__content">
          <div class="cart-addon-modal__header">
            <div class="cart-addon-modal__title-wrapper">
              <div class="wrapper-header-svg">
                <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M9.16667 18.1083C9.42003 18.2546 9.70744 18.3316 10 18.3316C10.2926 18.3316 10.58 18.2546 10.8333 18.1083L16.6667 14.775C16.9198 14.6288 17.13 14.4187 17.2763 14.1657C17.4225 13.9126 17.4997 13.6256 17.5 13.3333V6.66663C17.4997 6.37435 17.4225 6.0873 17.2763 5.83426C17.13 5.58122 16.9198 5.37109 16.6667 5.22496L10.8333 1.89163C10.58 1.74535 10.2926 1.66833 10 1.66833C9.70744 1.66833 9.42003 1.74535 9.16667 1.89163L3.33333 5.22496C3.08022 5.37109 2.86998 5.58122 2.72372 5.83426C2.57745 6.0873 2.5003 6.37435 2.5 6.66663V13.3333C2.5003 13.6256 2.57745 13.9126 2.72372 14.1657C2.86998 14.4187 3.08022 14.6288 3.33333 14.775L9.16667 18.1083Z" stroke="white" stroke-width="1.66667" stroke-linecap="round" stroke-linejoin="round"/>
                  <path d="M10 18.3333V10" stroke="white" stroke-width="1.66667" stroke-linecap="round" stroke-linejoin="round"/>
                  <path d="M2.74164 5.83337L9.99997 10L17.2583 5.83337" stroke="white" stroke-width="1.66667" stroke-linecap="round" stroke-linejoin="round"/>
                  <path d="M6.25 3.55835L13.75 7.85002" stroke="white" stroke-width="1.66667" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
                <h2 class="cart-addon-modal__title">COMPLETE YOUR ORDER</h2>
              </div>
              <div>
                <h2 class="cart-addon-modal__subtitle">Recommended Add-ons for ${this.productTitle}</h2>
              </div>
            </div>
            <button class="cart-addon-modal__close" data-action="close-modal" aria-label="Close modal">
              <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                <line x1="18" y1="6" x2="6" y2="18"></line>
                <line x1="6" y1="6" x2="18" y2="18"></line>
              </svg>
            </button>
          </div>

          <div class="cart-addon-modal__success-message" style="display: none;">
            <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
              <rect width="16" height="16" rx="8" fill="#00C950"></rect>
              <path d="M11.2009 5.59778L6.79968 9.99596L4.79913 7.99679" stroke="white" stroke-width="1.1995" stroke-linecap="round" stroke-linejoin="round"></path>
            </svg>
            <span class="cart-addon-modal__success-text" data-product-added=""></span>
          </div>

          <div class="cart-addon-modal__products-wrapper">
            <div class="cart-addon-modal__products" data-product-list></div>
          </div>

          <div class="cart-addon-modal__actions">
            <button class="cart-addon-modal__button cart-addon-modal__button--primary" data-action="add-selected">
              Add selected bundles to cart
            </button>
            <button class="cart-addon-modal__button--secondary" data-action="close-modal">
              No thanks, go to cart
            </button>
          </div>

          <div class="cart-addon-modal__loading" style="display: none;">
            <div class="cart-addon-modal__spinner"></div>
            <p>Adding items to cart...</p>
          </div>
        </div>
      </div>
    `;

    const tempDiv = document.createElement('div');
    tempDiv.innerHTML = modalHTML;
    document.body.appendChild(tempDiv.firstElementChild);
  }

  injectStyles() {
    if (document.getElementById('cart-addon-modal-styles')) {
      return;
    }

    const style = document.createElement('style');
    style.id = 'cart-addon-modal-styles';
    style.textContent = `
      .cart-addon-modal {
        position: fixed;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        z-index: 9999;
        display: flex;
        align-items: center;
        justify-content: center;
        animation: fadeIn 0.3s ease;
        background: rgba(0, 0, 0, 0.50);
      }

      @keyframes fadeIn {
        from { opacity: 0; }
        to { opacity: 1; }
      }

      @keyframes slideUp {
        from { 
          opacity: 0;
          transform: translateY(20px);
        }
        to { 
          opacity: 1;
          transform: translateY(0);
        }
      }

      .cart-addon-modal__overlay {
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        background: rgba(0, 0, 0, 0.5);
        cursor: pointer;
      }

      .wrapper-header-svg {
        display: flex;
        gap: 8px;
      }

      .cart-addon-modal__content {
        position: relative;
        background: white;
        width: 90%;
        max-width: 600px;
        max-height: 90vh;
        overflow: hidden;
        animation: slideUp 0.3s ease;
        box-shadow: 0 20px 60px rgba(0, 0, 0, 0.3);
      }

      .cart-addon-modal__header {
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding: 16px 20px;
        background: #003366;
        position: sticky;
        top: 0;
        color: white;
      }

      .cart-addon-modal__title-wrapper {
        display: flex;
        gap: 1px;
        flex-direction: column;
      }

      .cart-addon-modal__title {
        margin: 0;
        color: rgba(255, 255, 255, 0.90);
        font-size: 14px;
        font-weight: 600;
        line-height: 20px;
      }

      .cart-addon-modal__subtitle {
        margin: 4px 0 0 0;
        color: #FFF;
        font-size: 20px;
        font-weight: 700;
        line-height: 25px;
      }

      .cart-addon-modal__close {
        background: none;
        border: none;
        color: white;
        cursor: pointer;
        padding: 8px;
        display: flex;
        align-items: center;
        justify-content: center;
        border-radius: 4px;
        transition: background 0.2s;
        flex-shrink: 0;
      }

      .cart-addon-modal__close:hover {
        background: rgba(255, 255, 255, 0.1);
      }

      .cart-addon-modal__success-message {
        display: flex;
        align-items: center;
        gap: 8px;
        padding: 12px 16px;
        background: #e8f5e9;
        color: #2e7d32;
        border-radius: 4px;
        margin: 16px;
        font-size: 14px;
        font-weight: 500;
      }

      .cart-addon-modal__products-wrapper {
        padding: 16px 20px 0px 20px;
        position: relative;
      }

      .cart-addon-modal__products {
        display: flex;
        flex-direction: column;
        gap: 16px;
        max-height: 350px;
        overflow-y: auto;
      }

      [data-added-badge] {
        display: flex;
        align-items: center;
        gap: 8px;
        padding: 12px;
        margin-bottom: 16px;
        border: 0.909px solid #B9F8CF;
        background: #F0FDF4;
      }

      [data-added-badge] span {
        color: #008236;
        font-size: 14px;
        font-style: normal;
        font-weight: 600;
        line-height: 20px;
      }

      .cart-addon-product {
        display: flex;
        gap: 16px;
        padding: 16px;
        border: 1px solid #DCDCDC;
        align-items: center;

      }

      .cart-addon-product__checkbox-wrapper {
        display: flex;
        align-items: center;
        justify-content: center;
        cursor: pointer;
        flex-shrink: 0;
        margin-top: 2px;
      }

      .cart-addon-product__checkbox {
        display: none !important;
      }

      .cart-addon-product__checkbox-icon {
        flex-shrink: 0;
        transition: all 0.2s ease;
      }

      .cart-addon-product__image {
        width: 80px;
        height: 80px;
        object-fit: cover;
        border-radius: 4px;
        flex-shrink: 0;
      }

      .cart-addon-product__content {
        flex: 1;
        min-width: 0;
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        height: 80px;
      }

      .cart-addon-product__name {
        margin: 0;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        color: #101828;
        font-size: 16px;
        font-weight: 700;
        line-height: 24px;
        letter-spacing: 0.4px;
      }
        .text-head-sub-head-wrapper>p{
            margin: 0;
    color: #4A5565;
    font-size: 12px;
    font-style: normal;
    font-weight: 500;
    line-height: 16px;
}
        }

      .cart-addon-product__description {
        font-size: 12px;
        color: #666;
        margin: 0 0 8px 0;
      }

      .cart-addon-product__price-wrapper {
        display: flex;
        align-items: center;
        gap: 6px;
        flex-wrap: wrap;
        margin-top: auto;
      }

      .cart-addon-product__compare-price {
        color: #6A7282;
        font-family: Rajdhani;
        font-size: 12px;
        font-style: normal;
        font-weight: 600;
        line-height: 16px;
        text-decoration-line: line-through;
        text-decoration: line-through;
      }

      .cart-addon-product__price {
        color: #101828;
        font-size: 18px;
        font-weight: 700;
        line-height: 28px;
      }

      .cart-addon-product__discount {
        background: #B3372B;
        padding: 2px 6px;
        color: #FFF;
        font-size: 12px;
        font-style: normal;
        font-weight: 700;
        line-height: 16px;
      }

      .cart-addon-modal__actions {
        display: flex;
        flex-direction: column;
        gap: 12px;
        padding: 20px;
        border-top: 1px solid #DCDCDC;
        background: #FFF;
        position: relative;
        z-index: 10;
      }

      .cart-addon-modal__button {
        padding: 15px 24px;
        border: none;
        cursor: pointer;
        transition: all 0.2s;
        text-align: center;
        font-size: 18px;
        font-weight: 700;
        line-height: 26px;
        letter-spacing: 0.35px;
        text-transform: uppercase;
      }

      .cart-addon-modal__button--primary {
        background: #0c3463;
        color: white;
      }

      .cart-addon-modal__button--primary:hover:not(:disabled) {
        background: #062547;
        box-shadow: 0 4px 12px rgba(12, 52, 99, 0.3);
      }

      .cart-addon-modal__button--primary:disabled {
        opacity: 0.6;
        cursor: not-allowed;
      }

      .cart-addon-modal__button--secondary {
        color: #000;
        text-align: center;
        font-size: 16px;
        font-weight: 500 !important;
        line-height: 24px;
        border: none;
        background: transparent;
        text-transform: none;
        cursor: pointer;
      }

      .cart-addon-modal__loading {
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        gap: 16px;
        padding: 40px 24px;
        text-align: center;
        background: rgba(255, 255, 255, 0.95);
        z-index: 20;
        border-radius: 4px;
      }

      .cart-addon-modal__spinner {
        width: 40px;
        height: 40px;
        border: 3px solid #f0f0f0;
        border-top-color: #0c3463;
        border-radius: 50%;
        animation: spin 0.8s linear infinite;
      }

      @keyframes spin {
        to { transform: rotate(360deg); }
      }

      @media (max-width: 769px) {
              .text-head-sub-head-wrapper>p{
font-size: 11px;
line-height: 14px; /* 127.273% */
}
        .cart-addon-modal__content {
          width: 95%;
          max-width: calc(100% - 20px);
          max-height: 95vh;
        }

        .cart-addon-modal__products-wrapper {
          padding: 20px 20px 0px 20px;
        }

        .cart-addon-product__name {
          font-size: 14px;
          line-height: 18px;
          letter-spacing: 0.4px;
        }

        .cart-addon-modal__button--secondary {
          font-size: 14px;
          line-height: 20px;
        }
      }
    `;

    document.head.appendChild(style);
  }

  setupEventListeners() {
    try {
      const addToCartBtn = document.querySelector(this.options.selectorAddToCartBtn);
      
      if (addToCartBtn) {
        addToCartBtn.addEventListener('click', (e) => this.handleAddToCart(e));
        this.log('Add to cart button listener attached');
      } else {
        this.log('Add to cart button not found, will retry...');
        setTimeout(() => this.setupEventListeners(), 1000);
        return;
      }

      this.modal.addEventListener('click', (e) => this.handleModalAction(e));

      // ============================================
// DETECT CLICK OUTSIDE CONTENT (ON MODAL CONTAINER)
// ============================================
this.modal.addEventListener('click', (e) => {
  // Check if click is on the modal container itself (not on content)
  const content = this.modal.querySelector('.cart-addon-modal__content');
  console.log('📍 [OUTSIDE CLICK] Modal clicked');
  console.log('📍 [OUTSIDE CLICK] Target:', e.target.className);
  console.log('📍 [OUTSIDE CLICK] Is content?', content.contains(e.target));
  
  // If click is NOT on the content box, it's outside = close and redirect
  if (!content.contains(e.target)) {
    console.log('🌐 [OUTSIDE CLICK] Clicked outside content - closing and redirecting');
    e.stopPropagation();
    e.preventDefault();
    this.closeModal();
    setTimeout(() => {
      console.log('🌐 [OUTSIDE CLICK] Redirecting to /cart now');
      window.location.href = '/cart';
    }, 500);
  }
}, true); // Capture phase - fires before other listeners

      const overlay = this.modal.querySelector('.cart-addon-modal__overlay');
      if (overlay) {
        overlay.addEventListener('click', (e) => {
          e.stopPropagation();
          e.preventDefault();
          this.log('Overlay clicked - closing modal');
          this.closeModal();
        });
      }

      this.modal.addEventListener('click', (e) => {
        if (e.target === this.modal) {
          this.log('Modal background clicked - closing');
          this.closeModal();
        }
      });

      document.addEventListener('keydown', (e) => {
        if (e.key === 'Escape' && this.modal.style.display !== 'none') {
          this.closeModal();
        }
      });

      this.log('Event listeners setup complete');
    } catch (error) {
      this.error('Error setting up event listeners:', error);
    }
  }

  handleAddToCart(e) {
    if (this.addToCartInProgress) return;

    this.addToCartInProgress = true;
    this.log('Add to cart clicked');

    setTimeout(() => {
      this.loadProductsAndShowModal();
      this.addToCartInProgress = false;
    }, 100);
  }

  loadProductsAndShowModal() {
    try {
      const cbbContainer = document.querySelector(this.options.selectorProductContainer);
      if (!cbbContainer) {
        this.log('CBB section not found on page - modal will not open');
        return;
      }

      this.products = this.extractProducts();

      if (this.products.length === 0) {
        this.log('No products found in CBB section - modal will not open');
        return;
      }

      this.modal = document.getElementById(this.options.modalId);
      
      if (this.modal) {
        const productList = this.modal.querySelector('[data-product-list]');
        if (productList) {
          productList.innerHTML = '';
        }
        
        const badges = this.modal.querySelectorAll('[data-added-badge]');
        badges.forEach(badge => badge.remove());
        
        const loading = this.modal.querySelector('.cart-addon-modal__loading');
        if (loading) {
          loading.style.display = 'none';
        }
      }

      this.renderProducts();
      this.openModal();
      this.setupProductCheckboxes();
    } catch (error) {
      this.error('Error loading products:', error);
    }
  }

  extractProducts() {
    const products = [];
    const productElements = document.querySelectorAll(this.options.selectorProductContainer);

    this.log(`Found ${productElements.length} product elements`);

    productElements.forEach((element, index) => {
      if (products.length >= this.options.maxProducts) return;

      const product = this.parseProductElement(element);
      if (product) {
        products.push(product);
        this.log(`Extracted product ${index + 1}:`, product.name);
      }
    });

    return products;
  }

  parseProductElement(element) {
    try {
      const linkElement = element.querySelector('a[data-href]');
      const imageElement = element.querySelector('[role="img"]');
      const nameElement = element.querySelector('.cbb-also-bought-product-name a');
      
      const salePriceElement = element.querySelector('.cbb-also-bought-product-sale-price .money');
      const regularPriceElement = element.querySelector('.cbb-also-bought-product-regular-price .money');
      const priceElement = salePriceElement || regularPriceElement;
      
      const comparePriceElement = element.querySelector('.cbb-also-bought-product-compare-at-price .money');

      if (!linkElement || !nameElement || !priceElement) {
        this.log('Skipping product - missing required elements');
        return null;
      }

      const href = linkElement.getAttribute('data-href');
      const name = nameElement.textContent.trim();
      const description = element.querySelector('.cbb-also-bought-product-name a').getAttribute('aria-label') || '';
      const price = priceElement.textContent.trim();
      const comparePrice = comparePriceElement ? comparePriceElement.textContent.trim() : '';
      
      let image = '';
      if (imageElement) {
        const bgImage = imageElement.style.backgroundImage;
        if (bgImage) {
          image = bgImage.match(/url\("(.+?)"\)/)?.[1] || '';
        }
      }

      if (!image) {
        this.log('Skipping product - no image found');
        return null;
      }

      return {
        name,
        description,
        price,
        comparePrice,
        image,
        href,
        selected: false
      };
    } catch (error) {
      this.error('Error parsing product element:', error);
      return null;
    }
  }

  formatPrice(price) {
    const numberMatch = price.match(/\$[\d,.]+/);
    return numberMatch ? numberMatch[0] : price;
  }

  renderProducts() {
    const productList = this.modal.querySelector('[data-product-list]');
    
    if (!productList) {
      this.error('Product list container not found');
      return;
    }

    productList.innerHTML = '';

    const badgeHTML = `
      <div data-added-badge>
        <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
          <rect width="16" height="16" rx="8" fill="#00C950"/>
          <path d="M11.2009 5.59778L6.79968 9.99596L4.79913 7.99679" stroke="white" stroke-width="1.1995" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
        <span>${this.escapeHtml(this.productTitle)} added to cart</span>
      </div>
    `;

    productList.insertAdjacentHTML('beforebegin', badgeHTML);

    this.products.forEach((product, index) => {
      const isChecked = index === 0;
      
      let discountBadge = '';
      if (product.comparePrice) {
        const comparePriceNum = parseFloat(product.comparePrice.replace(/[^\d.]/g, ''));
        const priceNum = parseFloat(product.price.replace(/[^\d.]/g, ''));
        if (comparePriceNum > priceNum) {
          const discount = Math.round(((comparePriceNum - priceNum) / comparePriceNum) * 100);
          discountBadge = `<span class="cart-addon-product__discount">-${discount}%</span>`;
        }
      }
      
      const productHTML = `
        <div class="cart-addon-product" data-product-index="${index}">
          <label class="cart-addon-product__checkbox-wrapper">
            <input 
              type="checkbox" 
              class="cart-addon-product__checkbox"
              data-product-index="${index}"
              ${isChecked ? 'checked' : ''}
            />
            <svg class="cart-addon-product__checkbox-icon" width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
              <rect x="0.5" y="0.5" width="19" height="19" fill="white"/>
              <rect x="0.5" y="0.5" width="19" height="19" stroke="#DDDDDD"/>
            </svg>
          </label>
          <img 
            src="${product.image}" 
            alt="${product.name}"
            class="cart-addon-product__image"
            loading="lazy"
          />
          <div class="cart-addon-product__content">
          <div class="text-head-sub-head-wrapper">
            <h3 class="cart-addon-product__name">${this.escapeHtml(product.name)}</h3>
            <p>CVF Product</p>
            </div>
            <div class="cart-addon-product__price-wrapper">
             <span class="cart-addon-product__price">${this.formatPrice(product.price)}</span>
              ${product.comparePrice ? `<span class="cart-addon-product__compare-price">${this.formatPrice(product.comparePrice)}</span>` : ''}
              ${discountBadge}
            </div>
          </div>
        </div>
      `;

      productList.insertAdjacentHTML('beforeend', productHTML);
    });

    this.log(`Rendered ${this.products.length} products`);
  }

  setupProductCheckboxes() {
    const checkboxes = this.modal.querySelectorAll('.cart-addon-product__checkbox');
    checkboxes.forEach(checkbox => {
      checkbox.addEventListener('change', (e) => {
        const index = parseInt(e.target.getAttribute('data-product-index'));
        this.products[index].selected = e.target.checked;
        this.updateCheckboxDisplay(e.target);
        this.updateAddButtonState();
      });
    });

    if (checkboxes.length > 0) {
      checkboxes[0].checked = true;
      this.products[0].selected = true;
      this.updateCheckboxDisplay(checkboxes[0]);
    }

    this.updateAddButtonState();
  }

  updateCheckboxDisplay(checkbox) {
    const wrapper = checkbox.closest('.cart-addon-product__checkbox-wrapper');
    const icon = wrapper.querySelector('.cart-addon-product__checkbox-icon');
    
    if (checkbox.checked) {
      icon.innerHTML = `
        <rect width="20" height="20" fill="#0C3463"/>
        <path d="M14 7.00854L8.5 12.0085L6 9.73582" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
      `;
    } else {
      icon.innerHTML = `
        <rect x="0.5" y="0.5" width="19" height="19" fill="white"/>
        <rect x="0.5" y="0.5" width="19" height="19" stroke="#DDDDDD"/>
      `;
    }
  }

  updateAddButtonState() {
    const addBtn = this.modal.querySelector('[data-action="add-selected"]');
    const hasSelection = this.products.some(p => p.selected);
    
    if (addBtn) {
      addBtn.disabled = !hasSelection;
    }
  }

  handleModalAction(e) {
    const action = e.target.closest('[data-action]')?.getAttribute('data-action');
    const clickTarget = e.target.closest('[data-action="close-modal"]');

    switch (action) {
      case 'close-modal':
        // Only redirect if it's the "No thanks" button, not overlay click
        if (clickTarget && clickTarget.classList.contains('cart-addon-modal__button--secondary')) {
          console.log('🔵 "No thanks" button clicked - closing and redirecting to /cart');
          this.closeModal();
          setTimeout(() => {
            window.location.href = '/cart';
          }, 500);
        } else if (clickTarget && clickTarget.classList.contains('cart-addon-modal__close')) {
          console.log('🔵 X button clicked - closing and redirecting to /cart');
          this.closeModal();
          setTimeout(() => {
            window.location.href = '/cart';
          }, 500);
        } else {
          console.log('🔵 Overlay clicked - just closing modal (no redirect)');
          this.closeModal();
        }
        break;
      case 'add-selected':
        this.addSelectedProductsToCart();
        break;
    }
  }

  async addSelectedProductsToCart() {
    const selectedProducts = this.products.filter(p => p.selected);

    if (selectedProducts.length === 0) return;

    this.showLoading(true);

    try {
      const itemsToAdd = selectedProducts.map(product => ({
        id: this.extractVariantId(product.href),
        quantity: 1
      }));

      for (const item of itemsToAdd) {
        await this.addItemToCart(item);
      }

      this.showLoading(false);
      this.showSuccessMessage(selectedProducts.length);

      // ✅ AUTO-CLOSE and REDIRECT after showing success for 1 second
      setTimeout(() => {
        this.closeModal();
        setTimeout(() => {
          window.location.href = '/cart';
        }, 300);
      }, 1000);

    } catch (error) {
      this.error('Error adding items to cart:', error);
      alert('Error adding items to cart. Please try again.');
      this.showLoading(false);
    }
  }

  extractVariantId(href) {
    const match = href.match(/variant=(\d+)/);
    return match ? match[1] : null;
  }

  async addItemToCart(item) {
    const response = await fetch(`${window.Shopify?.routes?.root || '/'}cart/add.js`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-Requested-With': 'XMLHttpRequest'
      },
      body: JSON.stringify(item)
    });

    if (!response.ok) {
      throw new Error(`Failed to add item: ${response.statusText}`);
    }

    return response.json();
  }

  showLoading(show) {
    const loading = this.modal.querySelector('.cart-addon-modal__loading');
    const badge = this.modal.querySelector('[data-added-badge]');

    if (show) {
      loading.style.display = 'flex';
      if (badge) badge.style.display = 'none';
    } else {
      loading.style.display = 'none';
      if (badge) badge.style.display = 'flex';
    }
  }

  showSuccessMessage(count) {
    const badge = this.modal.querySelector('[data-added-badge]');
    const badgeSpan = badge ? badge.querySelector('span') : null;
    
    if (badge && badgeSpan) {
      badgeSpan.textContent = 'Items added to cart';
      badge.style.display = 'flex';
    }
  }

  openModal() {
    if (this.modal) {
      this.modal.style.display = 'flex';
      document.body.style.overflow = 'hidden';
      
      if (this.options.onModalOpen) {
        this.options.onModalOpen();
      }

      this.log('Modal opened');
    }
  }

  closeModal() {
    console.log('🔴 closeModal() called');
    
    if (this.modal) {
      console.log('  - Modal found, hiding it');
      this.modal.style.display = 'none';
      
      // Re-enable scrolling
      document.body.style.overflow = 'auto';
      document.documentElement.style.overflow = 'auto';
      
      // Clear modal content
      const badges = this.modal.querySelectorAll('[data-added-badge]');
      badges.forEach(badge => badge.remove());
      
      const loading = this.modal.querySelector('.cart-addon-modal__loading');
      if (loading) {
        loading.style.display = 'none';
      }
      
      const checkboxes = this.modal.querySelectorAll('.cart-addon-product__checkbox');
      checkboxes.forEach(checkbox => {
        checkbox.checked = false;
      });
      
      const productList = this.modal.querySelector('[data-product-list]');
      if (productList) {
        productList.innerHTML = '';
      }
      
      this.products = [];

      if (this.options.onModalClose) {
        this.options.onModalClose();
      }

      console.log('✅ closeModal() complete');
    }
  }

  escapeHtml(text) {
    const map = {
      '&': '&amp;',
      '<': '&lt;',
      '>': '&gt;',
      '"': '&quot;',
      "'": '&#039;'
    };
    return text.replace(/[&<>"']/g, m => map[m]);
  }

  log(message, data = null) {
    if (this.options.debugMode) {
      console.log(`[CartAddonModal] ${message}`, data || '');
    }
  }

  error(message, error = null) {
    console.error(`[CartAddonModal] ${message}`, error || '');
  }
}

// JUST INITIALIZE THE CLASS - DO NOT ACTIVATE
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => {
    window.cartAddonModal = new CartAddonModal({
      debugMode: false,
      maxProducts: 5,
      selectorProductContainer: '.cbb-also-bought-product',
      selectorAddToCartBtn: 'button[name="add"]'
    });
  });
} else {
  window.cartAddonModal = new CartAddonModal({
    debugMode: false,
    maxProducts: 5,
    selectorProductContainer: '.cbb-also-bought-product',
    selectorAddToCartBtn: 'button[name="add"]'
  });
}